import type { DTOLocation } from './DTOLocation';
import type { DTOProfileMediaInfo } from './DTOProfileMediaInfo';

export const DTO_FOLLOW_INFO_STATE_TYPES = {
  /** 내가 요청한 친구신청 상태 */
  REQUESTED_BY_USER: 'REQUESTED_BY_USER',

  /** 상대가 요청한 친구신청 상태 */
  REQUESTED_BY_PEER: 'REQUESTED_BY_PEER',

  /** 상대가 요청한 친구신청 상태 */
  IGNORED_BY_USER: 'IGNORED_BY_USER',

  /** 수락된 정식 친구 상태 */
  ACCEPTED: 'ACCEPTED',

  /** 상대와 아무런 관계도 아닌 경우 */
  NONE: 'NONE',
} as const;

export type DTOFollowInfoState =
  (typeof DTO_FOLLOW_INFO_STATE_TYPES)[keyof typeof DTO_FOLLOW_INFO_STATE_TYPES];

/**
 * Follow, Follower 사용자 목록 요소에 대한 정보를 담고 있는 DTO.
 * 클라에서 로컬 캐시를 안쓰고, 필요할 때 서버에 새로 조회하는 방식입니다.
 * Follow 하위 UI에 필요한 정보를 한번에 로딩하는 패턴을 지양하고, 목록 구성에 최소한으로 필요한 정보만 내려줍니다.
 */
export interface DTOFollowInfo {
  followId: string;

  state?: DTOFollowInfoState;

  nickname: string;

  messageThreadId?: string;

  favorite: boolean;

  profileMediaInfo?: DTOProfileMediaInfo;

  location: DTOLocation;

  recentlyAdded: boolean;

  isOnline: boolean;

  lastOnlineAt: number;

  onlineType?: string;

  liveDeeplink?: string;

  isFromLive: boolean;
}
